import { render, staticRenderFns } from "./PropertyInsurancePolicyDetails.vue?vue&type=template&id=39c1389c&scoped=true"
import script from "./PropertyInsurancePolicyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyInsurancePolicyDetails.vue?vue&type=script&lang=js"
import style0 from "./PropertyInsurancePolicyDetails.vue?vue&type=style&index=0&id=39c1389c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1389c",
  null
  
)

export default component.exports